import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { catchError, of } from 'rxjs';
import { PublicApiService } from '../core/api/public-api.service';
import { PublicMerchant } from '../core/api/api.types';

/** Resolves `/:code` to a merchant; unknown or inactive codes go to the not-found page. */
export const merchantCodeResolver: ResolveFn<PublicMerchant | null> = (route) => {
  const router = inject(Router);
  const code = route.paramMap.get('code') ?? '';
  return inject(PublicApiService)
    .merchantByCode(code.toUpperCase())
    .pipe(
      catchError(() => {
        void router.navigate(['/not-found'], { replaceUrl: true });
        return of(null);
      }),
    );
};
